import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { useProduct } from '@src/library/hooks/shop';

import Specifications from '../product/frames/Specifications';
import { useWindowWidth } from '@shared/hooks';

export const SpecificationPage: FC = () => {
	const navigate = useNavigate();
	const product = useProduct();

	const windowWidth = useWindowWidth();

	return (
		<>
			{windowWidth <= 768 ? (
				<Specifications specifications={product.info.specifications} />
			) : (
				navigate(`/shop/store/products/product/${product.productId}`)
			)}
		</>
	);
};
